"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettings = getSettings;
exports.getSettingsLoadingStatus = getSettingsLoadingStatus;
function getSettings(state) {
    if (state.editableSettings.settings.data) {
        return state.editableSettings.settings.data;
    }
    else {
        throw new Error('Editable settings data is not available.');
    }
}
function getSettingsLoadingStatus(state) {
    return state.editableSettings.settings.status;
}
